module.exports = __webpack_public_path__ + "static/img/logo_dark.6f5e0494.svg";